import React from 'react';
import styled from '@emotion/styled';
import { PODCAST_AD_DEFINITIONS } from 'client/screens/AdsByAnchorScreen/constants';

const Container = styled.div`
  max-width: 960px;
  margin: auto;
`;

const Heading = styled.h2`
  margin: 0 0 50px;
  font-size: 3.6rem;
`;

const DefinitionList = styled.dl`
  max-width: 790px;
  width: 100%;
  font-size: 1.6rem;
`;

const DefinitionContainer = styled.div`
  margin-bottom: 30px;
  dt,
  dd {
    display: inline;
    line-height: 3rem;
  }
`;

export function Glossary() {
  return (
    <Container>
      <Heading>Podcast Ads Glossary:</Heading>
      <DefinitionList>
        {PODCAST_AD_DEFINITIONS.map(({ term, definition }) => {
          return (
            <DefinitionContainer>
              <dt>{term}</dt>
              <dd>
                {` - `} {definition}
              </dd>
            </DefinitionContainer>
          );
        })}
      </DefinitionList>
    </Container>
  );
}
